import styles from './settingsPage.less'; export {styles};
import CookieOption, {CookieOptionType} from '../../cookieOption';
import Option from './settingsPage/option';

interface SettingsPageProps {
    cookieOptions: CookieOption[];
    onClickAgreeAll: () => void;
    onClickAgreeSelected: (options: CookieOption[]) => void;
}

export default class SettingsPage extends React.Component<SettingsPageProps, null> {

    private readonly _options: CookieOption[] = [];

    constructor(props) {
        super(props);

        this._options = Object.assign([], this.props.cookieOptions);
        this._options.unshift(new CookieOption(
            CookieOptionType.TECHNICAL,
            _('[COOKIES_MODAL] Technical cookies'),
            _('[COOKIES_MODAL] TECHNICAL DESCRIPTION'),
            true
        ));
    }

    render() {
        return (
            <>
                <div className={styles.body}>
                    {this._options.map((option) =>
                        <Option
                            key={option.getType()}
                            option={option}
                        />
                    )}
                </div>
                <div className={styles.buttons}>
                    <div className={classNames(styles.button)} onClick={() => this.props.onClickAgreeSelected(this._options)}>{_('[COOKIES_MODAL] I agree to the use of selected cookies')}</div>
                    <div className={classNames(styles.button, styles.conversion)} onClick={() => this.props.onClickAgreeAll()}>{_('[COOKIES_MODAL] I agree to the use of all cookies')}</div>
                </div>
            </>
        );
    }
}
